module.exports = __webpack_public_path__ + "static/media/exclamation.713ad92b.svg";